module.exports = __webpack_public_path__ + "static/img/mall_tab_icon_3_2.c76f655.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mall/mall_tab_icon_3_2.png
// module id = Pldc
// module chunks = 0